import React, { useState, useRef } from "react";
import { FaBars } from "react-icons/fa";

// Importing components
import NFTProject from "./components/NFTProject";
import Gallery from "./components/Gallery";
import CodersAidFund from "./components/CodersAidFund";
import Partners from "./components/Partners";
import PeopleInvolved from "./components/PeopleInvolved";
import News from "./components/News";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Button from "./components/Button";
import FAQ from "./components/FAQ"; // Add FAQ component
import PrivacyPolicy from "./components/PrivacyPolicy"; // Add Privacy Policy component
import TermsOfUse from "./components/TermsOfUse"; // Add Terms of Use component
import Donate from "./components/Donate"; // Add Donate component
import "./App.css";

function App() {
  const [navOpen, setNavOpen] = useState(false);
  const toggleNav = () => setNavOpen(!navOpen);

  // Creating refs for each section
  const sections = {
    home: useRef(null),
    nftProject: useRef(null),
    gallery: useRef(null),
    codersAidFund: useRef(null),
    partners: useRef(null),
    peopleInvolved: useRef(null),
    news: useRef(null),
    faq: useRef(null),
    privacy: useRef(null),
    terms: useRef(null),
    donate: useRef(null),
  };

  // Updated scrollToSection function with better null checks
  const scrollToSection = (key) => {
    console.log("Scrolling to:", key); // Log the key that was clicked
    console.log("Section reference:", sections[key]?.current); // Log the reference for the section

    setNavOpen(false); // Close the menu when a link is clicked

    // Add a null check for the section ref before calling scrollIntoView
    if (sections[key]?.current) {
      console.log("Scrolling into view:", sections[key].current); // Log the element being scrolled to
      sections[key].current.scrollIntoView({ behavior: "smooth" });
    } else {
      console.error(`Section ${key} is null or not available`); // Log if the section doesn't exist
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <FaBars className="menu-icon" onClick={toggleNav} />
        <div className="button-container">
          <Button />
        </div>
      </header>

      {navOpen && <div className="backdrop" onClick={toggleNav}></div>}

      <nav className={navOpen ? "nav-open" : ""}>
        <ul>
          {Object.keys(sections).map((key) => (
            <li key={key}>
              <a onClick={() => scrollToSection(key)}>
                {key.replace(/^\w/, (c) => c.toUpperCase())}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <main className="main-content">
        {/* Sections with refs */}
        <section ref={sections.home}>
          <Home />
        </section>
        <section ref={sections.nftProject}>
          <NFTProject />
        </section>
        <section ref={sections.gallery}>
          <Gallery />
        </section>
        <section ref={sections.codersAidFund}>
          <CodersAidFund />
        </section>
        <section ref={sections.partners}>
          <Partners />
        </section>
        <section ref={sections.peopleInvolved}>
          <PeopleInvolved />
        </section>
        <section ref={sections.news}>
          <News />
        </section>
        <section ref={sections.faq}>
          <FAQ />
        </section>
        <section ref={sections.privacy}>
          <PrivacyPolicy />
        </section>
        <section ref={sections.terms}>
          <TermsOfUse />
        </section>
        <section ref={sections.donate}>
          <Donate />
        </section>
      </main>

      {/* Footer component with scrollToSection passed as prop */}
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}

export default App;
